import React, { useContext, useEffect } from "react";
import clsx from "clsx";
import { menuController } from "@ionic/core/components";
import { menu as menuIcon } from "ionicons/icons";
import {
  IonButton,
  IonCol,
  IonGrid,
  IonIcon,
  IonLabel,
  IonRow,
  IonSegment,
  IonSegmentButton,
  useIonRouter,
} from "@ionic/react";

import {
  Context,
  fetchStatusRenewaled,
  sharedRealizationListPath,
  submittedRealizationListPath,
} from "../../../store/teacher";

import styles from "./NavToolbar.module.scss";

interface Props {
  defaultSegment: "timeline" | "submitted_stock";
}

const NavToolbar = ({ defaultSegment }: Props) => {
  const FONT_WEIGHT_BOLD = 700;
  const { contextState, dispatch } = useContext(Context);
  const history = useIonRouter();

  const showBadgeForSubmitted = React.useMemo(() => {
    return (
      !!contextState.my_box?.has_unread_realization ||
      contextState.boxesDashboard.some(b => b.has_unread_realization)
    );
  }, [contextState.my_box, contextState.boxesDashboard]);

  const showBadgeForShared = React.useMemo(() => {
    return (
      Object.values(contextState.unread_shared_per_class).reduce(
        (accum, current) => accum + current,
        0,
      ) > 0
    );
  }, [contextState.unread_shared_per_class]);

  useEffect(() => {
    const timer = setInterval(() => dispatch(fetchStatusRenewaled()), 60000);
    return () => {
      clearInterval(timer);
    };
  }, [dispatch]);

  return (
    <IonGrid className={styles.grid}>
      <IonRow>
        <IonCol className={styles.col}>
          <IonButton
            className={styles.button}
            fill="clear"
            onClick={() => menuController.open("sideMenuContainer")}
          >
            {contextState.unread_notification_count > 0 && (
              <div className={styles.badge}>●</div>
            )}
            <IonIcon icon={menuIcon} className={styles.icon} />
          </IonButton>
        </IonCol>
        <IonCol className={styles.col}>
          <IonSegment
            className={styles.segment}
            mode="md"
            value={defaultSegment}
          >
            <IonSegmentButton
              className={clsx(
                styles.segmentButton,
                styles.submittedStockSegment,
              )}
              value="submitted_stock"
              onClick={() => history.push(submittedRealizationListPath, "none")}
            >
              <IonLabel
                className={styles.label}
                style={{
                  fontWeight:
                    defaultSegment === "submitted_stock" && FONT_WEIGHT_BOLD,
                }}
              >
                {showBadgeForSubmitted && <span className={styles.badge} />}
                提出されたストック
              </IonLabel>
            </IonSegmentButton>
            <IonSegmentButton
              className={clsx(styles.segmentButton, styles.timelineSegment)}
              value="timeline"
              onClick={() => history.push(sharedRealizationListPath, "none")}
            >
              <IonLabel
                className={styles.label}
                style={{
                  fontWeight: defaultSegment === "timeline" && FONT_WEIGHT_BOLD,
                }}
              >
                {showBadgeForShared && <span className={styles.badge} />}
                タイムライン
              </IonLabel>
            </IonSegmentButton>
          </IonSegment>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default NavToolbar;
